var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_748_1334",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_748_1334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 21V9C16 7.9 15.6083 6.95833 14.825 6.175C14.0417 5.39167 13.1 5 12 5C10.9 5 9.95833 5.39167 9.175 6.175C8.39167 6.95833 8 7.9 8 9V13.2L9.6 11.6L11 13L7 17L3 13L4.4 11.6L6 13.2V9C6 7.33333 6.58333 5.91667 7.75 4.75C8.91667 3.58333 10.3333 3 12 3C13.6667 3 15.0833 3.58333 16.25 4.75C17.4167 5.91667 18 7.33333 18 9V21H16Z",
    fill: "#3A5F77"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg9);
export default __webpack_public_path__ + "static/media/9.cd5ab3525eacf1e0024f67868b0c6e52.svg";
export { ForwardRef as ReactComponent };